import React, {useState} from 'react'
import {Stack, Typography} from '@mui/material'
import {Link} from 'react-router-dom'
import {PATHS, STATUS} from 'src/constants/constants'
import apiClient from 'src/services/apiClient'
import Button from 'src/components-new/primitives/Button'
import InlineMessage from 'src/components-new/feedback/InlineMessage'

interface ConfirmationStepProps {
  email: string
}

/**
 * Terminal screen — new-style equivalent of
 * src/pages/selfRegistration/steps/ThirdStep/ThirdStep.tsx. Not part of the numbered
 * StepProgress (it's a completion state, reached only after `postSelfRegistration`
 * succeeds), same as how PasswordRecoveryPageNew's success state replaces the form
 * in-place rather than being counted as a step.
 *
 * Two additions over the legacy screen: success feedback on resend (legacy had none) and
 * a "Torna al login" link (every other pre-auth page has one).
 */
export default function ConfirmationStep({email}: ConfirmationStepProps): JSX.Element {
  const [status, setStatus] = useState<string>()

  const handleResend = async () => {
    await apiClient.sendConfirmSelfRegistration(email, setStatus)
  }

  return (
    <Stack spacing={2.5}>
      <Typography variant="body1">
        {'Ti abbiamo inviato una mail alla casella di posta che hai indicato in fase di registrazione. Clicca sul link contenuto per confermare la tua registrazione e accedere ai servizi.'}
      </Typography>

      {status === STATUS.REJECTED && (
        <InlineMessage severity="error">
          {"Non è stato possibile inviare nuovamente l'email. Riprova."}
        </InlineMessage>
      )}
      {status === STATUS.FULFILLED && (
        <InlineMessage severity="success">
          {'Email inviata nuovamente.'}
        </InlineMessage>
      )}

      <Button
        variant="ghost"
        onClick={handleResend}
        loading={status === STATUS.PENDING}
        sx={{alignSelf: 'flex-start', px: 0}}
      >
        {'Richiedi il rinvio della email'}
      </Button>

      <Link to={PATHS.LOGIN} style={{textDecoration: 'none'}}>
        <Typography variant="body2" sx={{color: 'primary.main'}}>
          {'Torna al login'}
        </Typography>
      </Link>
    </Stack>
  )
}
